import React from "react";
import { fmtDate } from "@/lib/api";

// Shared table of "what is affected" counts, in label order (dated first, then masters)
export const CountsTable = ({ counts, labels, selected, onToggle, rangeLabel, testId = "counts-table" }) => (
  <div className="rounded border overflow-hidden" data-testid={testId}>
    <table className="w-full text-sm">
      <thead className="bg-[hsl(var(--surface-2))] text-[11px] uppercase tracking-wide">
        <tr>
          {onToggle && <th className="w-10 px-2 py-2"></th>}
          <th className="text-left px-3 py-2">Item</th>
          <th className="text-right px-3 py-2">Records{rangeLabel ? ` (${rangeLabel})` : ""}</th>
        </tr>
      </thead>
      <tbody>
        {Object.entries(labels).map(([key, label]) => (
          <tr key={key} className={`border-t ${onToggle ? "cursor-pointer hover:bg-white/5" : ""}`}
            onClick={onToggle ? () => onToggle(key) : undefined} data-testid={`count-row-${key}`}>
            {onToggle && (
              <td className="px-2 py-1.5 text-center">
                <input type="checkbox" checked={!!selected?.has(key)} onChange={() => onToggle(key)}
                  onClick={(e) => e.stopPropagation()} className="h-4 w-4 accent-[hsl(var(--ruby))]"
                  data-testid={`wipe-check-${key}`} />
              </td>
            )}
            <td className="px-3 py-1.5">{label}</td>
            <td className="px-3 py-1.5 text-right font-mono-num" data-testid={`count-${key}`}>{counts?.[key] ?? "—"}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

export const rangeText = (from, to) => (!from && !to ? "all time" : `${from ? fmtDate(from) : "start"} → ${to ? fmtDate(to) : "today"}`);

// Native date inputs emit partial years while typing (e.g. 0002-09-01); treat those as "not entered yet"
export const isCompleteDate = (d) => /^\d{4}-\d{2}-\d{2}$/.test(d || "") && d >= "1900-01-01";
export const dateParam = (d) => (isCompleteDate(d) ? d : undefined);
export const rangeProblem = (from, to) => {
  if ((from && !isCompleteDate(from)) || (to && !isCompleteDate(to))) return "Finish typing the date";
  if (from && to && from > to) return "From date must be on or before To date";
  return null;
};
